import { dismissTourFeedback, submitTourFeedback } from '@repo/api';
import {} from '@repo/utils';
/** Delay before the next queued prompt appears after closing one. */
const TOUR_FEEDBACK_GAP_MS = 2000;
export const chatTourFeedbackInitialState = {
    tourFeedbackPrompts: [],
    tourFeedbackIsSubmitting: false,
    tourFeedbackGap: false,
};
let tourFeedbackGapTimer = null;
export function createChatTourFeedbackActions({ getSlice, setSlice }) {
    // After closing a prompt, hold the next one back so the sheet/modal fully
    // closes and reopens (rather than just swapping content).
    const startGap = () => {
        if (tourFeedbackGapTimer)
            clearTimeout(tourFeedbackGapTimer);
        setSlice({ tourFeedbackGap: true });
        tourFeedbackGapTimer = setTimeout(() => {
            tourFeedbackGapTimer = null;
            setSlice({ tourFeedbackGap: false });
        }, TOUR_FEEDBACK_GAP_MS);
    };
    return {
        // Overwrite the pending list straight from the socket, same as unread count.
        setTourFeedbackPrompts: (prompts) => {
            setSlice({ tourFeedbackPrompts: Array.isArray(prompts) ? prompts : [] });
        },
        // The first prompt in the list is the one shown. Dismissing drops it, then
        // the next one appears after a short gap. We also tell the backend the
        // prompt was dismissed (fire-and-forget) so it isn't re-served.
        dismissActiveTourFeedbackPrompt: () => {
            const dismissed = getSlice().tourFeedbackPrompts[0];
            setSlice(prev => ({ tourFeedbackPrompts: prev.tourFeedbackPrompts.slice(1) }));
            startGap();
            if (dismissed) {
                void dismissTourFeedback(dismissed.id).catch(error => {
                    console.error('[tour-feedback] dismiss failed', error);
                });
            }
        },
        // Returns true when the feedback was accepted by the backend, so callers
        // can decide whether to show a success screen.
        submitActiveTourFeedbackPrompt: async (payload) => {
            if (getSlice().tourFeedbackIsSubmitting)
                return false;
            setSlice({ tourFeedbackIsSubmitting: true });
            try {
                await submitTourFeedback(payload);
            }
            catch (error) {
                console.error('[tour-feedback] submit failed', error);
                setSlice({ tourFeedbackIsSubmitting: false });
                return false;
            }
            setSlice(prev => ({
                tourFeedbackIsSubmitting: false,
                tourFeedbackPrompts: prev.tourFeedbackPrompts.filter(p => p.id !== payload.tourId),
            }));
            startGap();
            return true;
        },
    };
}
